import { useSelector } from "react-redux";
import { ExperimentGroup, UserExperiments } from "./const";
import { selectExperimentGroup } from "../store/selectors";

export const usePreScoringExperiment = () =>
  useSelector(selectExperimentGroup(UserExperiments.preScoring)) ===
  ExperimentGroup.B;
